import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import { useAuth } from '../services/MVP/useAuth';
import { fetchAndCacheCmsBlock } from '../services/MVP/useCmsBlockService';

const useCmsBlockPrefetch = (blockIds: string[]): void => {
  const userLoaded = useSelector(
    (state: ApplicationState) => state.user.userLoaded
  );
  const { getHeaders } = useAuth();
  const blockIdsKey = blockIds.join(',');

  useEffect(() => {
    if (!userLoaded) return;
    blockIds.forEach((blockId) => fetchAndCacheCmsBlock(blockId, getHeaders()));
  }, [userLoaded, blockIdsKey]);
};

export default useCmsBlockPrefetch;
